module.exports = __webpack_public_path__ + "static/img/katakura_07.1f65aa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/katakura_07.jpg
// module id = Q/RB
// module chunks = 0